import type { TenantVerticalLiteral } from "@eduviaos/shared";
import { clientFacingText } from "@/lib/verticalProfile";

export interface FunnelCopy {
  description: string;
  skipStagesHint: string;
  defaultBadge: string;
  resetTitle: string;
  resetBody: string;
}

export function funnelCopy(vertical: TenantVerticalLiteral): FunnelCopy {
  const say = (text: string) => clientFacingText(vertical, text);
  return {
    description: say(
      "The stages prospective students pass through, from first contact to admitted / rejected. Reorder by dragging, rename inline, and link a form or action-gated requirements per stage.",
    ),
    skipStagesHint:
      vertical === "study_centre"
        ? "Your team can move an enquiry forward more than one stage at a time."
        : "Staff can move an enquiry forward more than one stage at a time.",
    defaultBadge: "Recommended",
    resetTitle: "Reset to recommended stages",
    resetBody:
      'Drops your customisation and brings back the recommended stages. Live enquiries are not touched, but any stage the reset removes shows as "(removed)" on existing enquiries.',
  };
}

export function asTenantVertical(value: string): TenantVerticalLiteral {
  return value === "study_centre" || value === "coaching_institute" ? value : "school";
}
